var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _g, _g2, _ellipse, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 60 60",
    viewBox: "0 0 60 60",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24 35v-9.75h0.034c-0.021 0.124-0.034 0.249-0.034 0.375 0-2.437 3.862-4.552 9.534-5.625h-29.926c-1.992 0-3.608 1.615-3.608 3.608v11.783c0 1.994 1.616 3.609 3.608 3.609h20.392v-4z",
    fill: "#424A60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m24.034 53h-0.034v-14h-20.392c-1.992 0-3.608 1.615-3.608 3.608v11.783c0 1.994 1.616 3.609 3.608 3.609h28.718c-4.725-1.069-7.948-2.897-8.292-5z",
    fill: "#556080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.392,20H3.608C1.616,20,0,18.384,0,16.392V4.608C0,2.616,1.616,1,3.608,1h50.783  C56.384,1,58,2.616,58,4.608v11.783C58,18.384,56.384,20,54.392,20z",
    fill: "#556080"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 10.5,
    r: 3.5,
    fill: "#7383BF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 9,
    r: 1,
    fill: "#7383BF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 9,
    r: 1,
    fill: "#7383BF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 12,
    r: 1,
    fill: "#7383BF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 12,
    r: 1,
    fill: "#7383BF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 9,
    r: 1,
    fill: "#7383BF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 12,
    r: 1,
    fill: "#7383BF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 9,
    r: 1,
    fill: "#7383BF"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 12,
    r: 1,
    fill: "#7383BF"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 9,
    r: 1,
    fill: "#7383BF"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 12,
    r: 1,
    fill: "#7383BF"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 29.5,
    r: 3.5,
    fill: "#7383BF"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 48.5,
    r: 3.5,
    fill: "#7383BF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1A9172"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42,48.75c-9.941,0-18-2.854-18-6.375V53h0.034c0.548,3.346,8.381,6,17.966,6s17.418-2.654,17.966-6   H60V42.375C60,45.896,51.941,48.75,42,48.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,42v0.375c0-0.126,0.013-0.251,0.034-0.375H24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.966,42C59.987,42.124,60,42.249,60,42.375V42H59.966z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#25AE88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42,38c-9.941,0-18-2.854-18-6.375V42.75h0.034c0.548,3.346,8.381,6,17.966,6s17.418-2.654,17.966-6   H60V31.625C60,35.146,51.941,38,42,38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,31.25v0.375c0-0.126,0.013-0.251,0.034-0.375H24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.966,31.25C59.987,31.374,60,31.499,60,31.625V31.25H59.966z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42,
    cy: 21.375,
    rx: 18,
    ry: 6.375,
    fill: "#88C057"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#61B872"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42,27.75c-9.941,0-18-2.854-18-6.375V32h0.034c0.548,3.346,8.381,6,17.966,6s17.418-2.654,17.966-6   H60V21.375C60,24.896,51.941,27.75,42,27.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,21v0.375c0-0.126,0.013-0.251,0.034-0.375H24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.966,21C59.987,21.124,60,21.249,60,21.375V21H59.966z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.4ca41eb733410168f5bfbb7b3a9affa0.svg";
export { ForwardRef as ReactComponent };